import { ReactNode } from "react";
import { create } from "zustand";

/* Store Types */
export interface ModalConfig {
  className?: string;
  closeOnClickOutside?: boolean;
}

interface ModalStore {
  isOpen: boolean;
  content: ReactNode | null;
  config: ModalConfig;
  modalActions: {
    open: (content: React.ReactNode, config?: ModalConfig) => void;
    close: () => void;
    setConfig: (config: ModalConfig) => void;
  };
}

/* Config */
const defaultConfig: ModalConfig = {
  className: "w-full max-w-[650px]",
  closeOnClickOutside: true,
};

/* Modal Store */
export const useModalStore = create<ModalStore>((set) => ({
  isOpen: false,
  content: null,
  config: defaultConfig,

  /* Actions */
  modalActions: {
    open: (content: ReactNode, config?: ModalConfig) =>
      set({
        isOpen: true,
        content,
        config: config || defaultConfig,
      }),
    close: () =>
      set({
        isOpen: false,
        content: null,
        config: defaultConfig,
      }),
    setConfig: (config: ModalConfig) => set({ config: config }),
  },
}));
